export default __webpack_public_path__ + "static/media/stanford_logo.33fa3b87.png";